<template>
    <div class="report-summary break-before-always">
        <hr class="d-print-none">
        <h2>Gesamtergebnis</h2>
        <report-score :score="assessment.reportOverallScore" title="Digitalisierungsgrad"/>
        <div class="row">
            <div class="col-5">
                <report-notes :editable="editable" :comment="comment" @update:comment="updateComment"/>
            </div>
            <div class="col-4 offset-1">
                <slot/>
            </div>
        </div>

        <h3>Legende</h3>
        <div class="progress mb-4">
            <div class="progress-bar bg-danger" style="width: 50%;">ungenügend (0-49%)</div>
            <div class="progress-bar bg-warning" style="width: 30%;">genügend (50-79%)</div>
            <div class="progress-bar bg-success" style="width: 20%;">ideal (80-100%)</div>
        </div>
        <div class="row">
            <div class="col-md-6">
                Das Resultat des Digitalisierungsgrad basiert auf {{ assessment.assessmentAnswerCount }} Fragen, welche durch einen zertifizierten Coach ausgewertet wurden.
                Das von Fachhochschulen entwickelte Framework lässt einen branchenübergreifenden Benchmark zu.
                In sieben verschiedene Kategorien (7-C Modell) kann so eine 360-Grad Analyse durchgeführt werden. Mit dem Ziel Ihnen konkrete und praxisorientierte Handlungsempfehlungen, im Rahmen einer persönlichen Beratung abzugeben.<br>
                <br>
                Weitere Infos zum Framework und zu den Kriterien finden Sie unter <a :href="frameworkUrl" target="_blank">{{ frameworkUrl }}</a>
            </div>
            <div class="col-md-6">
                <img src="../../../../assets/images/framework.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    import Assessment from '../../../../models/Assessment';

    import ReportScore from './Score';
    import ReportNotes from './Notes';

    export default {
        components: {
            ReportScore,
            ReportNotes,
        },

        props: {
            assessment: {
                type: Assessment,
                required: true,
            },
            editable: {
                type: Boolean,
                required: true,
            },
            comment: String,
        },

        computed: {
            frameworkUrl: () => `${window.location.origin}/framework`,
        },

        methods: {
            updateComment(value) {
                this.$emit('update:comment', value);
            },
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .report-summary {
        .progress {
            height: 40px;
            margin: 2rem 0 !important;
            font-size: 1.3rem;
        }
    }
</style>
